import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";

priceStyles.productPrice = {
    wrapper: {
        css: css`
            border: 1px solid;
            padding: 6px 5px 5.5px;
            margin-right: 10px;
            text-align: center;
            width: calc(100% - 10px);
        `,
    },
    price: {
        priceText: { size: 15 },
        unitOfMeasureText: { size: 26 },
    },
    savingsMessageText: {
        italic: true,
        size: "12px",
        css: css`
            position: absolute;
            bottom: -30px;
            left: 0;
        `,
    },
};